<template>
  <div class="background">
    <!-- GF1: gömülü modda (?gom=1) profil/izin kontrolü bitene kadar içerik çizilmez (kilitliyse hiç
         $Servis çağrısı yapılmasın). gom yokken gomuluDurum.hazir created'da anında true → fark yok. -->
    <div v-if="gomulu.kilitli" class="gf-kilit">
      <i class="pi pi-lock" style="font-size: 1.5rem" />
      <p class="mt-2 mb-0 font-semibold">Bu form bu sitede kullanılamaz</p>
    </div>
    <transition
      v-else-if="gomulu.hazir"
      name="fade"
      mode="out-in"
    >
      <div v-if="showView">
        <router-view />
      </div>
    </transition>
    <!-- KDU-7 (K7): kaydedilmemiş değişiklik onayı (services/kirliKayit.js), ayrı grup; public sayfada rozet yok -->
    <ConfirmDialog group="kirli" :draggable="false" />
  </div>
</template>

<script>
import "@/assets/gomulu-form.css";
import { onaySorucuAyarla, onaySorucuKaldir, confirmSorucusu } from "@/services/kirliKayit";
import { gomuluDurum, baslat as gomuluBaslat } from "@/services/gomulu";

export default {
  data() {
    return {
      showView: true,
      gomulu: gomuluDurum
    };
  },
  created() {
    // GF1: çocuk formlar mount olmadan önce (created) — gömülü değilse senkron olarak hazir=true
    gomuluBaslat(this.$Servis);
  },
  mounted() {
    this._kirliSorucu = confirmSorucusu(this.$confirm);
    onaySorucuAyarla(this._kirliSorucu);
  },
  beforeUnmount() {
    onaySorucuKaldir(this._kirliSorucu);
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>
